import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-close-indicator md:hidden",
  "data-testid": "sheet-modal-close-indicator"
}
const _hoisted_2 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "mt-6 self-stretch text-center justify-start text-white text-3xl font-bold px-[10%]"
}
const _hoisted_5 = {
  key: 3,
  class: "mt-2 text-text-neutral-high text-base px-[10%] text-center"
}
const _hoisted_6 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_7 = { class: "action-buttons w-full gap-3 flex-col flex" }

import { computed } from "vue";
import { VueFinalModal } from 'vue-final-modal'
import BaseButton from "@/components/ui/BaseButton.vue";
import { useEmitter } from '@nguyenshort/vue3-mitt';
import { ref, onMounted, onUnmounted } from "vue";
import {XMarkIcon} from "@heroicons/vue/24/outline";

export default /*@__PURE__*/_defineComponent({
  __name: 'SheetModal',
  props: {
    title: {},
    subtitle: {},
    icon: {},
    fullscreen: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    hasConfirm: { type: Boolean, default: false },
    confirmLabel: { default: 'common_done' },
    hasCancel: { type: Boolean, default: false },
    top: { type: Boolean, default: false },
    exactWidth: {},
    scrollable: { type: Boolean, default: true },
    blocking: { type: Boolean, default: false },
    hasClose: { type: Boolean, default: true },
    bodyClass: { default: 'px-10 pt-7 pb-6' }
  },
  emits: ['confirm', 'commit', 'update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emitter = useEmitter()

const props = __props

const emit = __emit

const contentClass = computed(() => {
  let defClass = `default-modal-content max-h-[90%] md:max-h-[70%] relative`;

  if (props.fullscreen) {
    defClass += ` default-modal-content--fullscreen`;
  }

  if (props.small) {
    defClass += ` default-modal-content--small`;
  }

  if (props.top) {
    defClass += ` default-modal-content--top`;
  }

  if (props.exactWidth) {
    defClass += ` ${props.exactWidth}`;
  }
  return defClass;
})

const overflow = computed(() => {
  if (props.scrollable) {
    return "auto";
  } else {
    return "hidden";
  }
})

const confirm = () => {
  emit('confirm');
  emit('update:modelValue', false)
}

const secondary = () => {
  emit('update:modelValue', false)
}
const isMobile = ref(window.innerWidth < 800);

const handleResize = () => {
  isMobile.value = window.innerWidth < 800;
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});

emitter.on('modalClose', () => {
  if (props.blocking) return
  emit('update:modelValue', false)
})

const iconUrl = computed(() => {
    if (props.icon) {
      return require('@/assets/icons/sorenson/' + props.icon + '.svg')
    }

    return "";
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "default-modal z-20",
    "content-class": contentClass.value,
    "content-transition": "vfm-slide-down",
    "overlay-transition": "vfm-fade",
    "swipe-to-close": __props.blocking || !isMobile.value ? undefined : 'down',
    "esc-to-close": !__props.blocking,
    "click-to-close": !__props.blocking,
    onClosed: secondary,
    "data-testid": "sheet-modal"
  }, {
    default: _withCtx(({}) => [
      (__props.hasClose)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = () => { secondary(); }),
            class: "text-white opacity-75 hover:opacity-100 cursor-pointer absolute right-3 top-3 hidden md:block"
          }, [
            _createVNode(_unref(XMarkIcon), { class: "size-7" })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("header", {
        class: _normalizeClass(["default-modal-header px-2 py-2 flex justify-center items-center flex-col", {'md:hidden': !__props.title}]),
        "data-testid": "sheet-modal-header"
      }, [
        (__props.hasClose)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true),
        (__props.icon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: iconUrl.value,
                alt: ""
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        (__props.title)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(__props.title), 1))
          : _createCommentVNode("", true),
        (__props.subtitle)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.subtitle), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["default-modal-slot gap-6 flex flex-col gap-7", [
          __props.bodyClass,
          `overflow-${overflow.value}`,
          __props.scrollable ? 'scrollbar-thumb-rounded-full scrollbar-thin scrollbar-track-rounded-full scrollbar scrollbar-thumb-[#f0f6ff57] scrollbar-track-transparent overflow-auto' : '',
        ]])
      }, [
        _renderSlot(_ctx.$slots, "default"),
        (__props.hasCancel || __props.hasConfirm)
          ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [
              _renderSlot(_ctx.$slots, "footer"),
              _createElementVNode("div", _hoisted_7, [
                (__props.hasConfirm)
                  ? (_openBlock(), _createBlock(BaseButton, {
                      key: 0,
                      level: "primary",
                      "full-width": "",
                      size: "medium",
                      onClick: _cache[1] || (_cache[1] = () => { confirm(); }),
                      "data-testid": "sheet-modal-confirm-button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(__props.confirmLabel) || 'Done'), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (__props.hasCancel)
                  ? (_openBlock(), _createBlock(BaseButton, {
                      key: 1,
                      level: "secondary",
                      "full-width": "",
                      size: "medium",
                      onClick: _cache[2] || (_cache[2] = () => secondary()),
                      "data-testid": "sheet-modal-cancel-button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common_cancel') || 'Cancel'), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 3
  }, 8, ["content-class", "swipe-to-close", "esc-to-close", "click-to-close"]))
}
}

})